import React from 'react';
import { Container, Grid, Link, Stack, Text } from 'basis';
import { LayoutPage, MinimumMonthlyPaymentDisclaimer } from 'components';
import AdrianaMartinezSignature from 'images/adriana_martinez.png';
import { ContractScheduleAnnualFeeDisclaimer, InterestFreePeriod } from 'components/earn-rate-tiers/Disclaimer';
import { isFeatureOn } from 'featureToggles';
import { PRODUCT_CODE_DAVID_JONES_PREMIERE } from '../../../../_config';
import { davidJonesTheme } from '../../../../theme';
import {
  StyledDivSpaceBetween,
  StyledLeftDivWidth75,
  StyledDivAlignRight,
  LightHr,
  ballotBoxWithTick,
  StyledTable,
  StyledTableRow,
  StyledTableCell,
  ballotBoxWithX,
} from './Styles';

export function DjFinancialTable({
  ratesAndFees,
  statementDate,
  downloadOrPrintFile,
  productName,
  accountNumber,
  creditLimit,
  productCode,
}) {
  const {
    purchaseAnnualRate,
    cashAnnualRate,
    annualFee,
    additionalCardHolderFee,
    lateFee,
    paperStatementFee,
    ausPostHandlingFee,
    minimumMonthlyPaymentAmount,
    minimumRepaymentRate,
    interestFreePeriod,
  } = ratesAndFees;

  return (
    <LayoutPage hideBackButton>
      <Text>
        <Container margin="0 0 0 0">
          <Container padding="5 0" padding-md="5" testId="LAYOUT FORM">
            <Grid preset="page" debug={false}>
              <Grid.Item colSpan="all">
                <Grid rowsGap={0}>
                  <Container padding="4 4" margin="0 8">
                    <div style={{ marginBottom: '40px' }}>
                      <Link variant="secondary" id="pdfButton" onClick={downloadOrPrintFile}>
                        Download or Print file
                      </Link>
                    </div>
                    <Grid preset="page" colsGap={11}>
                      <Grid.Item colSpan="all">
                        <Grid rowsGap={1}>
                          <Container padding="0">
                            <div id="financial-table">
                              <Stack gap="1">
                                <Text
                                  as="h1"
                                  textStyle="heading5"
                                  textStyle-md="heading4"
                                  color={davidJonesTheme.headingColor}
                                >
                                  Contract Schedule for your {productName} credit card
                                </Text>
                                <div style={{ marginTop: '20px' }}>
                                  <Text textStyle="heading6">Offer to New {productName} Account Holders</Text>
                                </div>
                                <Text>
                                  Latitude Finance Australia ABN 42 008 583 588 Australian Credit Licence number 392145,
                                  as the credit provider, offers to provide you with a {productName} credit card and
                                  account on the conditions set out in the Credit Contract.
                                </Text>
                                <br />
                                <Text>
                                  Our offer will be accepted immediately when you or an additional card holder activate
                                  or use the card we provide, add it to a digital wallet, draw on the account, or
                                  authorise or make a transaction on the account.
                                </Text>
                                <br />
                                <Text>Signed on behalf of Latitude Finance Australia.</Text>
                                <br />
                                <img src={AdrianaMartinezSignature} width="150px" alt="form-title-icon" />
                                <Text>
                                  <strong>Adriana Martinez</strong>
                                </Text>
                                <Text>Executive General Manager, Pay</Text>
                                <br />
                                <Text textStyle="heading5">Overview of your {productName} credit card</Text>
                                <hr />
                                <Text>
                                  As per the David Jones Credit Card General Terms and Conditions ('General Terms and
                                  Conditions'), the following features are available through your {productName} credit
                                  card:
                                </Text>
                                <LightHr />
                                <StyledTable>
                                  <StyledTableRow>
                                    <StyledTableCell flex={0.2} style={{ fontSize: '26px' }}>
                                      {ballotBoxWithTick}
                                    </StyledTableCell>
                                    <StyledTableCell flex={1.3}>Cash advance facility</StyledTableCell>
                                    <StyledTableCell flex={2}>Available</StyledTableCell>
                                  </StyledTableRow>
                                  <StyledTableRow>
                                    <StyledTableCell flex={0.2} style={{ fontSize: '26px' }}>
                                      {ballotBoxWithTick}
                                    </StyledTableCell>
                                    <StyledTableCell flex={1.3}>Balance transfers</StyledTableCell>
                                    <StyledTableCell flex={2}>Available</StyledTableCell>
                                  </StyledTableRow>
                                  <StyledTableRow>
                                    <StyledTableCell flex={0.2} style={{ fontSize: '26px' }}>
                                      {ballotBoxWithTick}
                                    </StyledTableCell>
                                    <StyledTableCell flex={1.3}>International transactions</StyledTableCell>
                                    <StyledTableCell flex={2}>Available</StyledTableCell>
                                  </StyledTableRow>
                                  <StyledTableRow>
                                    <StyledTableCell flex={0.2} style={{ fontSize: '26px' }}>
                                      {ballotBoxWithX}
                                    </StyledTableCell>
                                    <StyledTableCell flex={1.3}>Interest Free Payment Plans</StyledTableCell>
                                    <StyledTableCell flex={2}>Not available</StyledTableCell>
                                  </StyledTableRow>
                                  <StyledTableRow>
                                    <StyledTableCell flex={0.2} style={{ fontSize: '26px' }}>
                                      {ballotBoxWithX}
                                    </StyledTableCell>
                                    <StyledTableCell flex={1.3}>
                                      Instalment Offer Plans (interest bearing)
                                    </StyledTableCell>
                                    <StyledTableCell flex={2}>Not available</StyledTableCell>
                                  </StyledTableRow>
                                </StyledTable>
                                <br />
                                <Text textStyle="heading5">Financial table</Text>
                                <hr />
                                <Text>
                                  The details below are correct as at the disclosure date. The financial table does not
                                  contain all of the pre-contractual information we are required by law to give you.
                                  Further terms and conditions (and an explanation of some of the words used in the
                                  financial table) are in the General Terms and Conditions. You must read this Contract
                                  Schedule together with the General Terms and Conditions.
                                </Text>
                                <br />
                                <StyledTable style={{ textAlign: 'center' }}>
                                  <StyledTableRow>
                                    <StyledTableCell>Account number</StyledTableCell>
                                    <StyledTableCell>Disclosure date</StyledTableCell>
                                    <StyledTableCell>Credit Limit</StyledTableCell>
                                  </StyledTableRow>
                                  <StyledTableRow>
                                    <StyledTableCell>{accountNumber}</StyledTableCell>
                                    <StyledTableCell>{statementDate}</StyledTableCell>
                                    <StyledTableCell>${creditLimit}</StyledTableCell>
                                  </StyledTableRow>
                                </StyledTable>
                                <br />
                                <Text textStyle="heading5">
                                  <strong>Cash limit</strong>
                                  {'\u00A0'}
                                  <i>(refer to your statement)</i>
                                </Text>
                                <hr />
                                <Text>
                                  A cash limit forms part of your credit limit and may be withdrawn in cash or cash
                                  equivalent transactions. In each statement we give you, we may notify you of any cash
                                  limit we impose, withdraw or change from time to time.
                                </Text>
                                <br />
                                <Text textStyle="heading5">Annual percentage rates</Text>
                                <hr />
                                <StyledTable>
                                  <StyledTableRow>
                                    <StyledTableCell flex={3}>
                                      Purchase Rate - applies to the general purchase balance
                                    </StyledTableCell>
                                    <StyledTableCell flex={1.3} style={{ textAlign: 'right' }}>
                                      <Text>{purchaseAnnualRate}% p.a.</Text>
                                    </StyledTableCell>
                                  </StyledTableRow>
                                  <StyledTableRow>
                                    <StyledTableCell flex={3}>
                                      Cash Advance Rate - applies to the cash advance balance
                                    </StyledTableCell>
                                    <StyledTableCell flex={1.3} style={{ textAlign: 'right' }}>
                                      <Text>{cashAnnualRate}% p.a.</Text>
                                    </StyledTableCell>
                                  </StyledTableRow>
                                  <StyledTableRow>
                                    <StyledTableCell flex={3}>
                                      Balance Transfer Rate - applies to balance transfer offers
                                    </StyledTableCell>
                                    <StyledTableCell flex={1.3} style={{ textAlign: 'right' }}>
                                      The Cash Advance Rate applies, unless a specific balance transfer rate is
                                      subsequently offered
                                    </StyledTableCell>
                                  </StyledTableRow>
                                </StyledTable>
                                <Text textStyle="heading5">Interest free periods</Text>
                                <hr />
                                <StyledTable>
                                  <StyledTableRow>
                                    <StyledTableCell flex={1.3}>
                                      Up to {interestFreePeriod} days
                                      <InterestFreePeriod />
                                    </StyledTableCell>
                                    <StyledTableCell flex={1}>
                                      <Text>
                                        <ol style={{ marginLeft: '-20px', marginTop: '-4px' }}>
                                          <li>
                                            General purchases of goods and services (not cash advances) may (subject to
                                            clause 2.), be interest free up to {interestFreePeriod} days from the
                                            transaction date.
                                          </li>
                                          <li>
                                            We do not charge interest on the general purchase balance for a statement
                                            period if during the previous statement period:
                                            <ol type="a" style={{ marginLeft: '-24px' }}>
                                              <li>
                                                you pay by the due date the modified closing balance, for the statement
                                                of account issued at the start of that statement period; or
                                              </li>
                                              <li>
                                                that statement of account did not require you to make a minimum monthly
                                                payment.
                                              </li>
                                            </ol>
                                            If you do not meet the requirements under this clause for a statement
                                            period, interest will be calculated using the Purchase Rate and charged on
                                            any outstanding amount of the general purchase balance during that statement
                                            period.
                                          </li>
                                        </ol>
                                      </Text>
                                    </StyledTableCell>
                                  </StyledTableRow>
                                </StyledTable>
                                <Text textStyle="heading5">Payments explained</Text>
                                <hr />
                                <StyledTable>
                                  <StyledTableRow>
                                    <StyledTableCell flex={1.3}>Minimum monthly payment</StyledTableCell>
                                    <StyledTableCell flex={1}>
                                      <Text>
                                        The minimum monthly payment for a statement period is an amount equal to the
                                        greater of ${minimumMonthlyPaymentAmount} or {minimumRepaymentRate}% of the
                                        closing balance, shown on your statement of account.
                                      </Text>
                                      <br />
                                      <Text>
                                        If your outstanding balance is less than ${minimumMonthlyPaymentAmount}, you
                                        must pay that balance.
                                      </Text>
                                      <MinimumMonthlyPaymentDisclaimer includeOutstandingBalanceMessage={false} />
                                    </StyledTableCell>
                                  </StyledTableRow>
                                  <StyledTableRow>
                                    <StyledTableCell flex={1.3}>Modified closing balance</StyledTableCell>
                                    <StyledTableCell flex={1}>
                                      <Text>
                                        The modified closing balance shown in each statement of account is the amount
                                        you need to pay by the due date to qualify for interest free days on general
                                        purchases.
                                      </Text>
                                    </StyledTableCell>
                                  </StyledTableRow>
                                </StyledTable>
                                <Text textStyle="heading5">Fees and charges</Text>
                                <hr />
                                <StyledDivSpaceBetween>
                                  <StyledLeftDivWidth75>
                                    <Text>
                                      An annual credit card fee will be charged when you or an additional cardholder
                                      first initiate a transaction on your account and will be payable on the date
                                      specified in your next account statement. After that it will be payable on each
                                      anniversary of that date.
                                    </Text>
                                  </StyledLeftDivWidth75>
                                  <StyledDivAlignRight>
                                    <Text>${annualFee?.toFixed(2)}</Text>
                                    {isFeatureOn('cvpV2') && <Text>Waived for the first year</Text>}

                                    <ContractScheduleAnnualFeeDisclaimer productCode={productCode} />
                                  </StyledDivAlignRight>
                                </StyledDivSpaceBetween>
                                <hr />
                                {productCode === PRODUCT_CODE_DAVID_JONES_PREMIERE && (
                                  <>
                                    <StyledDivSpaceBetween>
                                      <StyledLeftDivWidth75>
                                        <Text>
                                          An annual additional cardholder fee will be charged pro-rata from the date the
                                          additional card is issued to the annual credit card fee anniversary date of
                                          the account and will be payable on the date specified in your next statement
                                          of account. After that it will be payable on each anniversary of the annual
                                          credit card fee date of the account.
                                        </Text>
                                      </StyledLeftDivWidth75>
                                      <Container>
                                        <Text>
                                          {Number.isNaN(Number.parseFloat(additionalCardHolderFee))
                                            ? additionalCardHolderFee
                                            : `$${Number.parseFloat(additionalCardHolderFee).toFixed(2)}`}
                                        </Text>
                                      </Container>
                                    </StyledDivSpaceBetween>
                                    <hr />
                                  </>
                                )}
                                <StyledDivSpaceBetween>
                                  <StyledLeftDivWidth75>
                                    <Text>
                                      A cash advance fee will be charged on each occasion on which you obtain a cash
                                      advance or make a cash equivalent transaction. This fee will not exceed $30 for
                                      that transaction.
                                    </Text>
                                  </StyledLeftDivWidth75>
                                  <StyledDivAlignRight>
                                    <Text>Greater of $3.00 or 3.00% of the cash advance amount</Text>
                                  </StyledDivAlignRight>
                                </StyledDivSpaceBetween>
                                <hr />
                                <StyledDivSpaceBetween>
                                  <StyledLeftDivWidth75>
                                    <Text>
                                      An international transaction fee of a specific percentage of the amount of the
                                      international transaction (as converted to Australian dollars if not originally in
                                      Australian dollars) will be charged when we process each international
                                      transaction.
                                    </Text>
                                  </StyledLeftDivWidth75>
                                  <StyledDivAlignRight>
                                    <Text>3.00% of the Australian dollar value of the international transaction</Text>
                                  </StyledDivAlignRight>
                                </StyledDivSpaceBetween>
                                <hr />
                                <StyledDivSpaceBetween>
                                  <StyledLeftDivWidth75>
                                    <Text>
                                      A balance transfer fee will be charged if you take up a balance transfer offer.
                                    </Text>
                                  </StyledLeftDivWidth75>
                                  <StyledDivAlignRight>
                                    <Text>
                                      Up to 3.00% of balance transfer amount or in accordance with the specific balance
                                      transfer offer
                                    </Text>
                                  </StyledDivAlignRight>
                                </StyledDivSpaceBetween>
                                <hr />
                                <StyledDivSpaceBetween>
                                  <StyledLeftDivWidth75>
                                    <Text>
                                      A late fee will be charged in each statement period when any amount due and
                                      payable to us is not paid in full by the due date.
                                    </Text>
                                  </StyledLeftDivWidth75>
                                  <StyledDivAlignRight>
                                    <Text>${lateFee?.toFixed(2)}</Text>
                                  </StyledDivAlignRight>
                                </StyledDivSpaceBetween>
                                <hr />
                                <StyledDivSpaceBetween>
                                  <StyledLeftDivWidth75>
                                    <Text>
                                      A paper statement fee will be charged for each paper statement of account sent to
                                      you. This fee will not be charged if you consent to receiving your statements
                                      electronically.
                                    </Text>
                                  </StyledLeftDivWidth75>
                                  <StyledDivAlignRight>
                                    <Text>${paperStatementFee?.toFixed(2)}</Text>
                                  </StyledDivAlignRight>
                                </StyledDivSpaceBetween>
                                <hr />
                                <StyledDivSpaceBetween>
                                  <StyledLeftDivWidth75>
                                    <Text>
                                      A payment handling fee will be charged each time you make a payment to your
                                      account at Australia Post. No fee is payable for payments made by BPAY®, direct
                                      debit or via the Latitude Service Centre or Mobile App.
                                    </Text>
                                  </StyledLeftDivWidth75>
                                  <StyledDivAlignRight>
                                    <Text>${ausPostHandlingFee?.toFixed(2)} (in person)</Text>
                                  </StyledDivAlignRight>
                                </StyledDivSpaceBetween>
                                <hr />
                                <StyledDivSpaceBetween>
                                  <StyledLeftDivWidth75>
                                    <Text>
                                      A credit balance processing fee will be charged when your account is closed and
                                      still holds a credit balance of less than $20.00; unless an instruction is
                                      provided to us on how to return the credit balance to you.
                                    </Text>
                                  </StyledLeftDivWidth75>
                                  <StyledDivAlignRight>
                                    <Text>The fee amount will be the lesser of your balance or $19.99</Text>
                                  </StyledDivAlignRight>
                                </StyledDivSpaceBetween>
                                <hr />
                                <Container>
                                  <Text>
                                    These fees and charges will be charged and debited to your account and will form
                                    part of the closing balance which is used to calculate your minimum monthly
                                    payments.
                                  </Text>
                                </Container>
                                <br />
                                <Container>
                                  <Text textStyle="heading5">Changes to the Credit Contract</Text>
                                </Container>
                                <hr />
                                <Container>
                                  <Text>
                                    Subject to applicable law, we may change the variable annual percentage rate(s),
                                    maximum interest free period, the amount, frequency or time for payment or method of
                                    calculation of a fee or charge or minimum monthly payment, reduce the credit limit,
                                    or impose new fees or charges. You will be notified of changes or new fees or
                                    charges in the manner set out in the General Terms and Conditions.
                                  </Text>
                                </Container>
                                <br />
                                <Container>
                                  <Text textStyle="heading5">Commission</Text>
                                </Container>
                                <hr />
                                <Text>
                                  An unascertainable commission may be payable for the introduction of this credit
                                  business to any merchant and related entity of a merchant which is involved in the
                                  introduction.
                                </Text>
                              </Stack>
                            </div>
                          </Container>
                        </Grid>
                      </Grid.Item>
                    </Grid>
                  </Container>
                </Grid>
              </Grid.Item>
            </Grid>
          </Container>
        </Container>
      </Text>
    </LayoutPage>
  );
}
